import { render, staticRenderFns } from "./shahmatka.vue?vue&type=template&id=6b0ea688"
import script from "./shahmatka.vue?vue&type=script&lang=js"
export * from "./shahmatka.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports